import { render, staticRenderFns } from "./permission-component.vue?vue&type=template&id=1ebb1f84&scoped=true"
import script from "./permission-component.vue?vue&type=script&lang=js"
export * from "./permission-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebb1f84",
  null
  
)

export default component.exports